 const ssnFormatter = (value) => {
  if (!value) return "";
  const digits = value.replace(/\D/g, "");
  const formatted = digits.replace(/(\d{3})(\d{2})(\d{4})/, "$1-$2-$3");
  return formatted.length > 11 ? formatted.slice(0, 11) : formatted; 
};

  export default ssnFormatter